import { render, staticRenderFns } from "./FuncionarioInvalidarTokens.vue?vue&type=template&id=6aa919b7&"
import script from "./FuncionarioInvalidarTokens.vue?vue&type=script&lang=js&"
export * from "./FuncionarioInvalidarTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports